import StarterpackList from './StarterpackList';
export default StarterpackList;



// WEBPACK FOOTER //
// ./src/pages/StarterpacksPage/components/StarterpackList/components/StarterpackList/index.ts